import type { ThemeDataOverride } from '@1js/suiteux-shell-react';
import { getCurrentThemeId, isUserPersonalizationAllowed, getPaletteAsRawColors } from 'owa-theme';
import type { OwaPalette } from 'owa-theme-shared';
import { getIsDarkTheme } from 'owa-fabric-theme';

const generateOpenBookCustomHeader = (themeId: string) => {
    const fluentTheme = getPaletteAsRawColors(themeId, getIsDarkTheme());
    return {
        LighterAlt: fluentTheme.themeLighterAlt,
        Darker: fluentTheme.themeDarker,
        Dark: fluentTheme.themeDark,
        DarkAlt: fluentTheme.themeDarkAlt,
        Light: fluentTheme.themeLight,
        Primary: fluentTheme.themePrimary,
        Secondary: fluentTheme.themeSecondary,
        Tertiary: fluentTheme.themeTertiary,
        Lighter: fluentTheme.themeLighter,
        NavBar: fluentTheme.white,
        DefaultText: fluentTheme.black,
        DefaultBackground: fluentTheme.white,
        HoverBackground: fluentTheme.themePrimary,
        AppName: fluentTheme.black,
        SearchNavBar: fluentTheme.white,
        SearchHoverBackground: fluentTheme.themeLighterAlt,
        SearchAccent: fluentTheme.themePrimary,
        FlexPaneAccent: fluentTheme.themePrimary,
    };
};
export default function (themeId: string = getCurrentThemeId()): ThemeDataOverride {
    const theme = {
        ...generateSuitePaletteFromFabricPalette(getPaletteAsRawColors(themeId)),
        ...generateOpenBookCustomHeader(themeId),
    };
    const themeData: ThemeDataOverride = {
        UserPersonalizationAllowed: isUserPersonalizationAllowed(),
        IsDarkTheme: getIsDarkTheme(),
        UserThemePalette: theme,
        PreferOfficeTheme: false,
        UserThemeId: themeId,
        TenantThemePalette: { ...theme },
    } as ThemeDataOverride;

    return themeData;
}

function generateSuitePaletteFromFabricPalette(palette: OwaPalette) {
    return {
        LighterAlt: palette.themeLighterAlt,
        Darker: palette.themeDarker,
        Dark: palette.themeDark,
        DarkAlt: palette.themeDarkAlt,
        Light: palette.themeLight,
        Primary: palette.themePrimary,
        Secondary: palette.themeSecondary,
        Tertiary: palette.themeTertiary,
        Lighter: palette.themeLighter,
        NavBar: palette.headerBackground,
        DefaultText: palette.headerTextIcons,
        DefaultBackground: palette.headerButtonsBackground,
        HoverBackground: palette.headerButtonsBackgroundHover,
        AppName: palette.headerBrandText,
        SearchNavBar: palette.headerBackgroundSearch,
        SearchHoverBackground: palette.headerButtonsBackgroundSearchHover,
        SearchAccent: palette.headerBadgeBackground,
    };
}
